import { Component, Mixins } from "vue-property-decorator";
import { DynPanelAware } from '@/components/dyn-panel';
import RightsAware from '@/lib/mixins/rights-aware';
import CavCavite from '@/lib/models/cav-cavite';
import { State, Getter } from 'vuex-class';
import XTable from '@/components/x-table';
import ActionTH from '@/components/x-table/action-th';
import XTh from '@/components/x-table/x-th';
import ActionTd from '@/components/x-table/action-td';
import CollectionControl from '@/components/collection-control';
import XInput from '@/components/x-input';
import CavDdtm59Link from '@/lib/models/cav-ddtm59-link';
import ControlCavDocuments from '@/modules/cavite-edit/components/control-documents';

@Component
export default class PartDDTM59Main extends Mixins(DynPanelAware, RightsAware) {

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  get links() {
    return this.data.ddtm59Links || [];
  }

  created() {}

  mounted() {}

  onAdd() {
    if (!this.data.ddtm59Links) {
      this.data.ddtm59Links = [new CavDdtm59Link()];
    } else {
      this.data.ddtm59Links.push(new CavDdtm59Link());
    }
  }

  onDelete(i) {
    this.data.ddtm59Links.splice(i, 1);
  }

  render() {
    if (!this.data) return null;
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="label is-small">Lien avec la base DDTM59</label>
              <CollectionControl
                data={this.links}
                clazz={null}
                withAddButton={(this.data.ddtm59Links?.length || 0) < 12}
                onAdd={this.onAdd}
                scopedSlots={{
                  body: ({ data }) => (
                    <XTable data={data}
                      class="is-full-width is-bordered is-small"
                      scopedSlots={{
                        header: () => (
                          <tr>
                            <XTh prop="titre">Lien</XTh>
                            <ActionTH/>
                          </tr>
                        ),
                        row: ({d, i}: {d: CavDdtm59Link, i: number}) => (
                          <tr>
                            <td><XInput class="input is-small"
                              vModel={d.link}
                              maxLength={15}
                              /></td>
                            <ActionTd
                              withEdit={false}
                              withOpen={false}
                              onDelete={() => this.onDelete(i)}
                            />
                          </tr>
                        )
                      }}>
                    </XTable>
                  )
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-78d6c9c4/main.tsx" });